// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container_3EUVG"};